module.exports = __webpack_public_path__ + "img/icon-dropdown-white.f876ad6d.svg";